import { render, staticRenderFns } from "./BrandingImageUpload.vue?vue&type=template&id=92c24030&scoped=true"
import script from "./BrandingImageUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandingImageUpload.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BrandingImageUpload.vue?vue&type=style&index=0&id=92c24030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c24030",
  null
  
)

export default component.exports